const {
	getMarketplaceAccountConfig,
	isMarketplaceServiceHidden,
	defaultMarketplaceConfig,
} = require('./accounts');

module.exports = {
	// api: 'https://api-voucher-viva.onwardsmg.com/v1',
	// api: 'https://cdn.craffview.com/v1', // prod
	// api: `${process.env.REACT_APP_BAMBOO_API || 'http://localhost:3008/v1'}`,
	api: `${process.env.REACT_APP_BAMBOO_API || 'https://api-viva.craffview.com/v1' || 'https://api-astro.craffview.com/v1'}`,
	apiQuery: `${process.env.REACT_APP_QUERY_API || 'https://api2.craffview.com/v1'}`,
	apiAlarm: `${'https://api.craffview.com/v1'}`,
	// apiAlarm: `${'https://d3mgbr7exrskcr.cloudfront.net/v1'}`, // prod
	version: `${process.env.REACT_APP_VERSION || '1.00.00'}`,
	apiHeaderXCraffviewEnv: `${process.env.REACT_APP_BAMBOO_CRAFFVIEW_ENV || 'development'}`,
	accountId: `${process.env.REACT_APP_ACCOUNT_ID || 'vivamax'}`,
	service: process.env.REACT_APP_SERVICE ? process.env.REACT_APP_SERVICE.split(',') : [],
	serviceTraffic: `${process.env.REACT_APP_SERVICE_TRAFFIC || 'https://traffic-astro.craffview.com/'}`,
	serviceAdvert: `${process.env.REACT_APP_SERVICE_ADVERT || 'https://advert-vivamax.craffview.com/'}`,
	serviceAudience: `${process.env.REACT_APP_SERVICE_AUDIENCE || 'https://audience-vivamax.craffview.com/'}`,
	serviceSearch: `${process.env.REACT_APP_SERVICE_SEARCH || 'https://search-vivamax.craffview.com/'}`,
	serviceCDN: `${process.env.REACT_APP_SERVICE_CDN || 'http://localhost:3002/'}`,
	serviceCAMPAIGN: `${process.env.REACT_APP_SERVICE_CAMPAIGN || 'http://localhost:3001'}`,
	serviceBytelive: `${process.env.REACT_APP_SERVICE_BYTELIVE || 'https://bytelive-vivamax.craffview.com/'}`,
	serviceDrm: `${process.env.REACT_APP_SERVICE_DRM || 'https://drm-vivamax.craffview.com/'}`,
	serviceAiTools: `${process.env.REACT_APP_SERVICE_AI_TOOLS || 'http://localhost:3033'}`,
	serviceReframe: `${process.env.REACT_APP_SERVICE_REFRAME || 'https://reframe-vivamax.craffview.com/'}`,
	servicePulse: `${process.env.REACT_APP_SERVICE_PULSE || 'https://pulse-vivamax.craffview.com/'}`,
	getMarketplaceAccountConfig,
	isMarketplaceServiceHidden,
	defaultMarketplaceConfig,
};
